import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';

import { BackendHealthMonitorService } from '../../services/common/backend-health-monitoring/backend-health-monitoring.service';

@Component({
	selector: 'app-health-status',
	imports: [CommonModule],
	template: `
		@if (showHealthStatus()) {
			<div class="health-banner unhealthy">
				<div class="status-content">
					<span class="status-icon">
						<i class="status-indicator offline"></i>
					</span>
					<div class="status-info">
						<h3>Dėmesio! Nėra ryšio</h3>
						@if (lastChecked()) {
							<p>Paskutinį kartą tikrinta: {{ lastChecked() | date: 'medium' }}</p>
						}
						<p class="attention-warning">
							Patikrinkite interneto ryšį ir VPN. Gali būti, kad esate neprisijungęs ir toliau į sistemą suvedami
							duomenys nebus išsaugoti.
						</p>
					</div>
				</div>
				<button (click)="refreshStatus()" class="refresh-btn" [disabled]="isChecking()" [attr.aria-busy]="isChecking()">
					{{ isChecking() ? 'Tikrinama...' : 'Tikrinti' }}
				</button>
			</div>
		}
	`,
	styles: [
		`
			.health-banner {
				position: fixed;
				bottom: 0;
				left: 0;
				width: 100%;
				z-index: 1000;
				padding: 16px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
				animation: slideUp 0.3s ease-out;
			}

			@keyframes slideUp {
				from {
					transform: translateY(100%);
				}
				to {
					transform: translateY(0);
				}
			}

			.unhealthy {
				background-color: #f8d7da;
				border-left: 4px solid #dc3545;
			}

			.status-content {
				display: flex;
				align-items: center;
				gap: 16px;
			}

			.status-icon {
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.status-indicator {
				display: inline-block;
				width: 16px;
				height: 16px;
				border-radius: 50%;
				position: relative;
			}

			.status-indicator.offline {
				background-color: #dc3545;
				box-shadow: 0 0 8px #dc3545;
			}

			.status-info h3 {
				margin: 0;
				font-size: 18px;
			}

			.status-info p {
				margin: 4px 0 0 0;
				font-size: 14px;
				color: #6c757d;
			}

			.attention-warning {
				color: #856404;
				background-color: #fff3cd;
				padding: 6px 10px;
				border-radius: 4px;
				margin-top: 8px !important;
				font-weight: 500;
			}

			.refresh-btn {
				padding: 8px 16px;
				background-color: #007bff;
				color: white;
				border: none;
				border-radius: 4px;
				cursor: pointer;
				min-width: 120px;
			}

			.refresh-btn:hover:not([disabled]) {
				background-color: #0069d9;
			}

			.refresh-btn:disabled {
				background-color: #6c757d;
				cursor: not-allowed;
			}
		`,
	],
})
export class HealthStatusComponent {
	private healthMonitor = inject(BackendHealthMonitorService);

	readonly monitoringStarted = this.healthMonitor.monitoringStarted;
	readonly isBackendHealthy = this.healthMonitor.isBackendHealthy;
	readonly lastChecked = this.healthMonitor.lastChecked;
	readonly isChecking = this.healthMonitor.isChecking;

	protected readonly showHealthStatus = computed(() => {
		return this.monitoringStarted() && !this.isBackendHealthy();
	});

	refreshStatus() {
		if (!this.isChecking()) {
			this.healthMonitor.checkBackendHealth().subscribe();
		}
	}
}
